import { ColumnOrderState } from "@tanstack/react-table";

import { PERIOD_GROUPING_FIELD_NAME } from "../../constants";
import { IReportActionParamsBase } from "../../models";
import { getIsFlexPeriodGroupingApplied } from "./reports.grid.helpers";

export const getReportColumnOrderState = ({
  reportApiDto,
  fetchCriteria,
}: IReportActionParamsBase): ColumnOrderState => {
  const {
    layout: { columns },
    report: { visibleColumns: visibleColumnsReport },
    reportTemplate: { periodGroupingColumn: periodGroupingColumnTemplate },
  } = reportApiDto;

  const columnOrderState: ColumnOrderState = [];
  const groupingColumns = fetchCriteria?.flexGrouping?.groupingParams;
  const isFlexPeriodTemplateApplied = getIsFlexPeriodGroupingApplied(
    periodGroupingColumnTemplate,
    fetchCriteria,
  );

  // Grouping columns always lead: period first, then flex grouping columns
  if (isFlexPeriodTemplateApplied) {
    columnOrderState.push(PERIOD_GROUPING_FIELD_NAME);
  }

  for (const col of groupingColumns ?? []) {
    if (!columnOrderState.includes(col)) {
      columnOrderState.push(col);
    }
  }

  if (visibleColumnsReport?.length) {
    // Append saved column order, skipping any grouping columns already added
    for (const dataColumnKey of visibleColumnsReport) {
      if (!columnOrderState.includes(dataColumnKey)) {
        columnOrderState.push(dataColumnKey);
      }
    }

    return columnOrderState;
  }

  // No saved order: append layout order, skipping any grouping columns already added
  for (const { columnTemplateKey } of columns) {
    if (!columnOrderState.includes(columnTemplateKey)) {
      columnOrderState.push(columnTemplateKey);
    }
  }

  return columnOrderState;
};
